import { Game } from "../../core/game/common/Game";
import { contact3DReplicatedActions, contact3DReplicatedObjects, contact3DReplicatedTimeoutConfigs } from "./Contact3DTypes";
;
export class Contact3D extends Game {
    constructor(stage) {
        super(stage, contact3DReplicatedObjects, contact3DReplicatedActions, contact3DReplicatedTimeoutConfigs);
    }
    onCommitEndGame(getWriterContext) {
        const context = getWriterContext();
        if (context.clue !== undefined) {
            context.clue.commitDelete();
        }
        context.gameState.commitData({
            numRevealedLetters: 1,
            currentAdjustment: 0,
            previousClues: [],
            guesses: [],
        }, {
            deleteKeys: ['secretWord']
        });
    }
    onInitializeGame(createReplicatedObject) {
        createReplicatedObject('Contact3DPlayerRecords', { record: {} });
        createReplicatedObject('GameState', { numRevealedLetters: 1, previousClues: [], currentAdjustment: 0, guesses: [] });
    }
    createStartGameAction() {
        this.replicatedActionClient.createReplicatedAction('Contact3DStartGame', {});
    }
    getPlayerRecordInput() {
        return {
            score: 0,
        };
    }
}
//# sourceMappingURL=Contact3D.js.map